//#region imports
import React, { useEffect, useState, useRef } from 'react'

import useAuth from '../../auth/useAuth';

import {
    settings, getDtRowIndex, getResponse, isUndNullEmpNew, getLanguageObj, LoadingSection, sendMessageCloseCurrentWindow, getError, getProcessButtons,
    isUndNullNew, setDateTimeFormatGlobal, setBadgeStatusGenericNew, awaitDelay
} from '../../helpers/UtilsHelper';

import Swal from 'sweetalert2';

import LlmModelAddEdit from './LlmModelAddEdit';
import Menu from '../main/Menu';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { SwalPropertiesClass } from '../../classes/main/swalPropertiesClass';
import TableIndex from '../main/TableIndex';
import { LargeLanguageModelService } from '../../services/largeLanguageModel/LargeLanguageModelService';
import { LargeLanguageModelClass } from '../../classes/ai/largeLanguageModelClass';
import { LlmModelService } from '../../services/largeLanguageModel/LlmModelService';
import { LlmModelClass } from '../../classes/ai/LlmModelClass';
//#endregion imports

const $ = window.$;

const { app, colors, html, icons, messages, labels, firebase, react, timers } = settings;
const { fields: dbFields, ordersBy: dbOrdersBy, operators: dbOperators } = firebase?.firestore;
const { urls } = app?.backend;
const { sweetAlert2, } = react;

const currentMethod = 'LlmModels - function';

export default function LlmModels({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    let data_ = {};

    const auth = useAuth();
    const selLargeLanguageModelsRef = useRef(null);
    const [largeLanguageModel, setLargeLanguageModel] = useState(LargeLanguageModelClass?.getClass());
    const [largeLanguageModels, setLargeLanguageModels] = useState([]);
    const [process, setProcess] = useState({ showLoading: false, add: false, selectLargeLanguageModels: false });
    const isMount = useRef(true);

    const dtLlmModelsId = 'dtLlmModelsId';

    const dateTimeFormat = {
        date: languageObj?.format?.date?.f1,
        time: languageObj?.format?.time?.type,
    };
    //#region variables llmModel (edit)
    const [showModal, setShowModal] = useState(false);
    const [llmModel, setLlmModel] = useState(LlmModelClass?.getClass());
    const [llmModels, setLlmModels] = useState([LlmModelClass?.getClass()]);
    const [processValues, setProcessValues] = useState({ id: '', description: '', dtId: dtLlmModelsId, dtRowId: 0, type: 0, subMethod: '' })
    const btnEnabledDisabledRef = useRef(null);
    const btnDeleteRef = useRef(null);
    const methodNames = { changeEnabled: 'changeEnabled' };
    //#endregion variables llmModel edit)
    //#endregion variables

    //#region process
    const setDataTable = ({
        subMethod = ''
    }) => {
        const currentMethod = 'setDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region Datatable
            $(`#${dtLlmModelsId}`).DataTable({
                destroy: true,
                //data: items,
                data: [],
                order: [[1, 'asc']],
                columns: [
                    { title: labels?.code?.[languageObj?.id], width: '25%', orderable: false, },
                    { title: labels?.description?.[languageObj?.id], width: '45%', orderable: true, },
                    { title: labels?.created?.[languageObj?.id], width: '15%', orderable: true, },
                    { title: labels?.enabled?.[languageObj?.id], className: 'text-center', width: '10%', orderable: false, },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis'],
            }).buttons().container().appendTo(`#${dtLlmModelsId}_wrapper .col-md-6:eq(0)`);

            //#endregion Datatable

            //#region set query code
            response = setQueryCode({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return response;
            //#endregion set query code
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setDataClear = ({
        dtLlmModelsId_ = false,
        subMethod = '',
    }) => {
        const currentMethod = 'setDataClear';
        let response = getResponse({ type: 0 });
        try {
            if (dtLlmModelsId_) $(`#${dtLlmModelsId}`).DataTable().rows().remove().draw(true);
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    }) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let id = '';
            let rowIndex = 0;
            let description = '';
            let methodValue = '';
            //#endregion variables

            //#region process
            $(`#${dtLlmModelsId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowIndex = getDtRowIndex(dtLlmModelsId, this, currentMethod)?.result;
                if (!isUndNullNew({ data: rowIndex, subMethod: currentMethod })?.result) {
                    methodValue = e?.target?.attributes?.method?.value || '';
                    id = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodValue) {
                        case 'edit':
                            await getLlmModelAddEditDelete({ e: e, id: id, description: description, rowIndex: rowIndex, type: 1, subMethod: currentMethod });
                            break;
                        case 'delete':
                            // await getLlmModelAddEditDelete({ e: e, id: id, description: description, rowIndex: rowIndex, type: -1, subMethod: currentMethod });
                            setProcessValues(prev => ({ ...prev, id: id, description: description, dtRowId: rowIndex, type: -1, subMethod: currentMethod }));
                            btnDeleteRef?.current?.click();
                            break;
                        case 'changeEnabled':
                            // await getLlmModelAddEditDelete({ e: e, id: id, description: description, rowIndex: rowIndex, type: 2, subMethod: currentMethod });
                            setProcessValues(prev => ({ ...prev, id: id, description: description, dtRowId: rowIndex, type: 2, subMethod: currentMethod }));
                            btnEnabledDisabledRef?.current?.click();
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const getData = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            response = setDataTable({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            data_ = {
                conditionals: [],
                ordersBy: [{ field: dbFields?.description, value: dbOrdersBy?.asc, },]
            };

            response = await LargeLanguageModelService?.getAll({
                token: auth?.account?.tokenVzLaML?.token,
                data: data_,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            setLargeLanguageModels(response?.result || []);

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const setDtRow = ({
        data = LlmModelClass?.getClass(),
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDtRow';
        let response = getResponse({ type: 0 });
        try {
            const attributes_ = {
                method: methodNames?.changeEnabled,
                id: data?.id,
                description: data?.description
            };
            const value_ = data?.enabled ?
                `<i class='${icons?.fasFa?.toggleOn}' method='${methodNames?.changeEnabled}' id='${data?.id}' description='${data?.code}'></i>` :
                `<i class='${icons?.fasFa?.toggleOff}' method='${methodNames?.changeEnabled}' id='${data?.id}' description='${data?.code}'></i>`;

            response.result = [
                data?.code,
                data?.description,
                setDateTimeFormatGlobal({
                    date: data?.created,
                    type: dateTimeFormat?.date,
                    format: dateTimeFormat?.time,
                    addTime: false,
                    withSeconds: false,
                    subMethod: currentMethod,
                })?.result,
                setBadgeStatusGenericNew({
                    type: data?.enabled ? 0 : 5,
                    value: value_,
                    title: data?.enabled ? labels?.enabled?.[languageObj?.id] : labels?.disabled?.[languageObj?.id],
                    attribues: attributes_,
                    pointer: true,
                }),
                getProcessButtons({
                    id: data?.id,
                    description: data?.description,
                    detailsShow: false,
                    detailsLabel: '',
                    detailsEnabled: false,
                    editShow: true,
                    editLabel: labels?.edit?.[languageObj?.id],
                    editEnabled: true,
                    deleteShow: true,
                    deleteLabel: labels?.delete?.[languageObj?.id],
                    deleteEnabled: true,
                    processButtons: [],
                    languageId: languageObj?.id,
                    subMethod: currentMethod
                })?.result,
            ];
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }
    //#endregion process

    //#region large language model (process)
    const getLargeLanguageModel = async ({
        largeLanguageModelId = '',
        showMessage = true,
        subMethod = '',
    }) => {
        const currentMethod = 'getLargeLanguageModel';
        let response = getResponse({ type: 0 });
        try {
            if (showMessage) setProcess(prev => ({ ...prev, showLoading: true, selectLargeLanguageModels: false }));

            //#region variables
            let largeLanguageModel = LargeLanguageModelClass?.getClass();
            //#endregion variables

            setLlmModels([]);

            //#region clear dataTables
            response = setDataClear({
                dtLlmModelsId_: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion clear dataTable

            //#region process
            if (!isUndNullEmpNew({ data: largeLanguageModelId, subMethod: currentMethod, })?.result) {
                //#region get large language model
                largeLanguageModel = largeLanguageModels.filter(({ id }) => id === largeLanguageModelId)?.[0] || {};
                if (!isUndNullEmpNew({ data: largeLanguageModel, subMethod: currentMethod })?.result) {
                    largeLanguageModel = largeLanguageModel?.[0] || largeLanguageModel;
                }
                //#endregion get large language model

                //#region check status user
                setProcess(prev => ({ ...prev, selectLargeLanguageModels: true }));
                setLargeLanguageModel(largeLanguageModel);
                //#endregion check status user

                //#region get large language model - models
                response = await getLlmModelsByLargeLanguageModelId({
                    largeLanguageModelId: largeLanguageModelId,
                    withLargeLanguageModel: true,
                    subMethod: currentMethod
                });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion get large language model - models
            } else {
                setLargeLanguageModel({});
            }
            //#endregion process
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            if (showMessage) setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }
    //#endregion large language model (process)

    //#region large language model - models (procss)
    const getLlmModelsByLargeLanguageModelId = async ({
        largeLanguageModelId = '',
        withLargeLanguageModel = false,
        subMethod = '',
    }) => {
        const currentMethod = 'getLlmModelsByLargeLanguageModelId';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let dtRows = [];
            let llmModels_ = [LlmModelClass?.getClass()];
            // let largeLanguageModel_ = LargeLanguageModelClass?.getClass();
            //#endregion variables

            //#region process
            //#region get data (large language model - models)
            data_ = {
                conditionals: [{ field: dbFields?.llmId, operator: dbOperators?.equal, value: largeLanguageModelId }],
                ordersBy: [{ field: dbFields?.description, value: dbOrdersBy?.asc }],
                limit: 0,
                withLargeLanguageModel: withLargeLanguageModel,
            };

            response = await LlmModelService.getAll({
                token: auth?.account?.tokenVzLaML?.token,
                data: data_,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

            llmModels_ = response?.result?.llmModels || [];
            // largeLanguageModel_ = response?.result?.largeLanguageModel || {};
            //#endregion get data (large language model - models)

            //#region set data in dataTable
            llmModels_?.forEach((model) => {
                dtRows.push(
                    setDtRow({
                        data: model,
                        subMethod: currentMethod
                    })?.result
                );
            });

            $(`#${dtLlmModelsId}`).DataTable().rows.add(dtRows).draw(true);
            //#endregion set data in dataTable
            //#endregion process

            setLlmModels(llmModels_);

            //#region old code
            // if(withLargeLanguageModel){
            //     const largeLanguageModels_ = largeLanguageModels?.map(llm => {
            //         if(llm?.id === largeLanguageModel_?.id){
            //             llm = largeLanguageModel_;
            //         }
            //         return llm;
            //     });
            //     setLargeLanguageModels(largeLanguageModels_);
            // }
            //#endregion old code
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const getLlmModelAddEditDelete = async ({
        e = {},
        id = '',
        description = '',
        rowIndex = 0,
        type = 0,
        subMethod = ''
    }) => {
        const currentMethod = 'getLlmModelAddEditDelete';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            if (type !== -1) setProcess(prev => ({ ...prev, showLoading: true, add: type === 0 }));

            setProcessValues(prev => ({
                ...prev,
                id: id,
                description: description,
                subMethod: currentMethod,
                dtRowId: rowIndex,
                type: type
            }));

            let llmModel_ = LlmModelClass?.getClass();

            switch (type) {
                case -1:
                    //#region show message
                    let msgTextObj = {
                        one: messages?.areYouSureDeleteThis?.[languageObj?.id],
                        two: `${labels?.model?.[languageObj?.id]}: <b>${description}</b><br/>`,
                        three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                    };

                    let swalProperties = SwalPropertiesClass?.getClass();
                    swalProperties = {
                        icon: sweetAlert2?.icons?.warning,
                        title: msgTextObj?.one,
                        html: `${msgTextObj?.two}${msgTextObj?.three}`,
                        timer: null,
                        backdrop: true,
                        confirmButtonColor: colors?.warningColorExp,
                        confirmButtonText: labels?.yes?.[languageObj?.id],
                        showCancelButton: true,
                        cancelButtonColor: colors?.successColorExp,
                        cancelButtonText: labels?.no?.[languageObj?.id],
                        showLoaderOnConfirm: true,
                        customClass: {
                            popup: html?.popup,
                            confirmButton: html?.buttons?.primary,
                            cancelButton: html?.buttons?.secondary,
                        },
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                        allowOutsideClick: () => !Swal?.isLoading(),
                        preConfirm: async () => {
                            let preConfirmResponse = getResponse({ type: 0 });
                            try {
                                Swal.getCancelButton().hidden = true;
                                Swal.update({
                                    icon: sweetAlert2?.icons?.info,
                                    title: `${messages?.processing?.[languageObj?.id]}`,
                                    html: `${msgTextObj?.two}`,
                                    showConfirmButton: false,
                                });

                                preConfirmResponse = await LlmModelService.delete({
                                    id: id,
                                    token: auth?.account?.tokenVzLaML?.token,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod
                                });
                                if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;

                                $(`#${dtLlmModelsId}`).DataTable().row(rowIndex).remove().draw(true);
                                preConfirmResponse.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;

                                setLlmModels(llmModels?.filter(model => model?.id !== id) || []);
                            } catch (ex) {
                                preConfirmResponse = getError({ ex: ex, response: preConfirmResponse, currentMethod_: currentMethod, subMethod_: subMethod });
                            }
                            return preConfirmResponse;
                        }
                    };
                    //#endregionshow message

                    const swalresult = await Swal.fire({
                        ...swalProperties,
                    });
                    if (swalresult?.isConfirmed && swalresult?.value) {
                        response = swalresult?.value;
                    } else if (swalresult?.isDismissed) {
                        response = getResponse({ type: 0 });
                    }
                    break;
                case 0:
                    llmModel_.llmId = selLargeLanguageModelsRef?.current?.value;
                    llmModel_.userId = auth?.account?.uid;
                    setLlmModel(llmModel_);
                    break;
                case 1:
                    response = await getLlmModelById({
                        id: id,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                    llmModel_ = response?.result || {};
                    setLlmModel(llmModel_);
                    break;
                default:
                    return;
            }

            if (type === 0) await awaitDelay({ delayTime: timers?.oneSeconds });
            if (type !== -1) setShowModal(true);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            if (type !== -1) setProcess(prev => ({ ...prev, showLoading: false, add: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const getLlmModelById = async ({
        id = '',
        subMethod = ''
    }) => {
        const currentMethod = 'getLlmModelById';
        let response = getResponse({ type: 0 });
        try {
            return await LlmModelService?.getById({
                id: id,
                token: auth?.account?.tokenVzLaML?.token,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    }

    const changeEnabled = async ({
        id = '',
        description = '',
        rowIndex = 0,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'changeEnabled';
        let response = getResponse({ type: 0 });
        try {
            id = processValues?.id;
            description = processValues?.description;
            rowIndex = processValues?.dtRowId;

            if (!id || rowIndex < 0) return;

            setProcess(prev => ({ ...prev, showLoading: true }));

            let llmModel = llmModels?.find(m => m?.id === id) || {};
            llmModel.enabled = !llmModel?.enabled;
            llmModel.languageId = languageObj?.id;

            response = await LlmModelService?.update({
                id: llmModel?.id,
                token: auth?.account?.tokenVzLaML?.token,
                data: llmModel,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            llmModel = response?.result || {}

            llmModels?.forEach(llm => {
                if (llm?.id === id) {
                    llm = llmModel;
                };
            });

            setLlmModels(llmModels);
            const dtRow = setDtRow({
                data: llmModel,
                subMethod: currentMethod
            })?.result;

            $(`#${dtLlmModelsId}`).DataTable().row(rowIndex).data(dtRow).draw(false);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }
    //#endregion large language model - models (process)

    //#region process (others)
    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => { isMount.current = false; };
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion process (others)

    return (
        <div>
            <Menu viewName={'settings'} process={'largeLanguageModels'} processLevel1={'llmModels'} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Premium Bar) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>
                                    {labels?.largeLanguageModels?.[languageObj?.id]} ({labels?.models?.[languageObj?.id]})
                                </h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.largeLanguageModels?.[languageObj?.id]} ({labels?.models?.[languageObj?.id]})</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-12'>

                                <div className={settings?.html?.cards?.default} >
                                    <LoadingSection alt='loadingSection'
                                        className='overlay dark text-white'
                                        height={20}
                                        hidden={!process?.showLoading}
                                        width={20}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header bg-white border-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt={labels?.model?.[languageObj?.id]}
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={settings?.images?.icons?.largeLanguageModels} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.largeLanguageModel?.[languageObj?.id]}</h5>
                                                </div>
                                            </div>
                                            <div className='card-tools'>
                                                <button type='button'
                                                    className='btn btn-tool'
                                                    data-card-widget='collapse'>
                                                    <i className={icons?.fasFa?.minus} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='card-body px-4 pb-0'>
                                        <div className='row'>
                                            {/* Select large language model */}
                                            <div className='col-12 col-md-4 mb-3'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                        {labels?.largeLanguageModel?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.brain} position-absolute input-icon-left`} />
                                                        <select className='form-control border-0 shadow-sm form-input-icon custom-select-premium'
                                                            ref={selLargeLanguageModelsRef}
                                                            onChange={(e) => getLargeLanguageModel({ largeLanguageModelId: e?.target?.value, showMessage: true, subMethod: 'getLargeLanguageModel' })}>
                                                            <option defaultValue value=''>{messages?.selectLargeLanguageModel?.[languageObj?.id]}</option>
                                                            {largeLanguageModels?.length > 0 ?
                                                                largeLanguageModels.map((largeLanguageModel) => (
                                                                    <option key={largeLanguageModel?.id} value={largeLanguageModel?.id}>{` ${largeLanguageModel?.description}`}</option>
                                                                ))
                                                                : null
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* code */}
                                            <div className='col-12 col-md-4 mb-3'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                        {labels?.code?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.key} position-absolute input-icon-left`} />
                                                        <input type='text'
                                                            className='form-control border-0 shadow-sm form-input-icon bg-light'
                                                            placeholder={labels?.code?.[languageObj?.id]}
                                                            value={largeLanguageModel?.code || ''}
                                                            title={labels?.code?.[languageObj?.id]}
                                                            readOnly />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* created */}
                                            <div className='col-12 col-md-4 mb-3'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                        {labels?.created?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.clock} position-absolute input-icon-left`} />
                                                        <input type='text'
                                                            className='form-control border-0 shadow-sm form-input-icon bg-light'
                                                            placeholder={labels?.created?.[languageObj?.id]}
                                                            value={largeLanguageModel?.code && largeLanguageModel?.created ?
                                                                setDateTimeFormatGlobal({
                                                                    date: largeLanguageModel?.created,
                                                                    type: dateTimeFormat?.date,
                                                                    format: dateTimeFormat?.time,
                                                                    addTime: false,
                                                                    withSeconds: false,
                                                                    subMethod: 'inputCreated',
                                                                })?.result :
                                                                ''}
                                                            title={labels?.created?.[languageObj?.id]}
                                                            readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            {/* Enabled */}
                                            <div className='col-12 col-md-3 mb-3'>
                                                <div className='form-group'>
                                                    <div className='icheck-primary d-inline'>
                                                        <input type='checkbox'
                                                            id='chkLargeLanguageModelEnabledId'
                                                            checked={largeLanguageModel?.enabled || false}
                                                            disabled={process?.showLoading}
                                                            readOnly />
                                                        <label htmlFor='chkLargeLanguageModelEnabledId' style={{ cursor: 'pointer' }}>
                                                            {labels?.enabled?.[languageObj?.id]}?
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-12 col-md-3 mb-3'>
                                                <div className='form-group'>
                                                    <button ref={btnEnabledDisabledRef}
                                                        className='btn btn-general border border-warning shadow-sm font-weight-bold px-4 text-secondary mx-1'
                                                        hidden={true}
                                                        data-title={labels?.edit?.[languageObj?.id]}
                                                        disabled={process?.showLoading || !selLargeLanguageModelsRef?.current?.value}
                                                        onClick={(e) => changeEnabled({ e: e })}
                                                        type='button'>
                                                        <i className={`${icons?.fasFa?.edit} mr-2`} />
                                                        {labels?.edit?.[languageObj?.id]}
                                                    </button>
                                                    <button ref={btnDeleteRef}
                                                        className='btn btn-general border border-danger shadow-sm font-weight-bold px-4 text-secondary'
                                                        hidden={true}
                                                        data-title={labels?.delete?.[languageObj?.id]}
                                                        disabled={process?.showLoading || !selLargeLanguageModelsRef?.current?.value}
                                                        onClick={(e) => getLlmModelAddEditDelete({
                                                            e: e,
                                                            id: processValues?.id,
                                                            description: processValues?.description,
                                                            rowIndex: processValues?.dtRowId,
                                                            type: processValues?.type,
                                                            subMethod: currentMethod
                                                        })}
                                                        type='button'>
                                                        <i className={`${icons?.fasFa?.trashAlt} mr-2`} />
                                                        {labels?.delete?.[languageObj?.id]}
                                                    </button>
                                                </div>
                                            </div>

                                            <div className='col-12 col-md-3 mb-3'>
                                                <div className='form-group'></div>
                                            </div>

                                            <div className='col-12 col-md-3 mb-3'>
                                                <div className='form-group'></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={settings?.html?.cards?.default} >
                                    <LoadingSection alt='loadingSection'
                                        className='overlay dark text-white'
                                        height={20}
                                        hidden={!process?.showLoading}
                                        width={20}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header bg-white border-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt={labels?.model?.[languageObj?.id]}
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={settings?.images?.icons?.llmModel} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.models?.[languageObj?.id]}</h5>
                                                    <div className='mt-1'>
                                                        <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={{ ...html?.badges?.micro }}>
                                                            <i className={`${icons?.fasFa?.list} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-tools'>
                                                <button type='button'
                                                    className='btn btn-tool'
                                                    data-card-widget='collapse'>
                                                    <i className={icons?.fasFa?.minus} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='card-body px-4 pb-4'>
                                        <div className='d-flex flex-wrap justify-content-end align-items-center mb-3' style={{ gap: '8px' }}>
                                            <button className='btn btn-primary shadow-sm font-weight-bold px-4'
                                                disabled={process?.showLoading || !process?.selectLargeLanguageModels}
                                                data-title={labels?.add?.[languageObj?.id]}
                                                onClick={(e) => getLlmModelAddEditDelete({ e: e, id: '', description: '', rowIndex: 0, type: 0, subMethod: 'btnAiAdd' })}>
                                                {!process?.add ? (
                                                    <i className={`${icons?.fasFa?.plusCircle} mr-1`}></i>
                                                ) : (
                                                    <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                )}  {labels?.add?.[languageObj?.id]}
                                            </button>
                                        </div>
                                        <TableIndex tableId={dtLlmModelsId} languageObj={languageObj} />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>{/* /.container-fluid */}

                    {showModal && (
                        <LlmModelAddEdit $={$}
                            auth={auth}
                            processValues={processValues}
                            showModal={showModal}
                            setShowModal={setShowModal}
                            llmModel={llmModel}
                            setLlmModel={setLlmModel}
                            llmModels={llmModels}
                            setLlmModels={setLlmModels}
                            largeLanguageModel={largeLanguageModel}
                            setLargeLanguageModel={setLargeLanguageModel}
                            setDtRow={setDtRow}
                            languageObj={languageObj} />
                    )}
                </section>
                {/* /.content */}

            </div>
        </div>
    )
}